export const windowWidth = (): number => window.innerWidth || document.documentElement.clientWidth;
